import type { FaireProductEntity } from "../../entity_types/product";

export const p_zy2dxdupqx: FaireProductEntity = {
  token: "p_zy2dxdupqx",
  type: "product",
  name: "Vintage Vibes RING",
  brandToken: "b_azjmuj2qt2",
  brandName: "Unknown Brand",
  imageUrl: "https://cdn.faire.com/fastly/5d7fe065cb94f05660d63428c2fc6c51e9af98cabaa8c97943daabbc103dbfca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/720bc2a078ea64c8ad64f5735709f1fd468c0bd26d36a7fab95f2625e8ee073f.jpeg",
    "https://cdn.faire.com/fastly/44df93dbc6a081873e0713bc5146cdb8373082f53a7cfca40c46cc60a3d32c93.jpeg",
    "https://cdn.faire.com/fastly/128204432b74ad9bae1f5e2b83b28238f680d5a0226135053bd20ec8ed338185.jpeg",
    "https://cdn.faire.com/fastly/dbcac92caf66e4544c998fab0a5430baf9d2c11e36061e1de66eb6d08c836d3c.jpeg",
    "https://cdn.faire.com/fastly/0c841f4d0b4b35761b3a02d50a884c453ade3b7c42666a9d41dafebb67cc3526.jpeg",
    "https://cdn.faire.com/fastly/b97af09b584fbf33338f78f4275a4e4fc622daff0abdf28ae3c14e04a5a5727c.jpeg",
    "https://cdn.faire.com/fastly/e79292115d55f95d8e563fd917397a986a7455489863ce0526f157b630a8fc75.jpeg",
    "https://cdn.faire.com/fastly/76345a4b78a751695e06b18e4c23b3613339b490ebc3e6c82a449d8d35661558.jpeg",
    "https://cdn.faire.com/fastly/0099d01d0d0debd06438e39378ed975ef9343952015b2d57d9829c55d71e1cca.jpeg",
    "https://cdn.faire.com/fastly/9ace9272e0c18b17a16b75d7d611a891e0db18c34da71be8db0aa2f9dc67b544.jpeg",
    "https://cdn.faire.com/fastly/43efcc74248ba2a3b5ad89c53a7cd58939651e843e673b129a48435180b28588.jpeg",
    "https://cdn.faire.com/fastly/d92c402c23454ef50b426864ff1d512d0046ab5619861691f7832fa05996fba8.jpeg"
  ],
  priceDollars: 14,
  description: "Bring your finger bling with this retro-inspired ring! Made of stainless steel, it’s an effortlessly cool way to add some ‘je ne sais quoi’ to any outfit. Choose your favorite of the four sweet colors and make it your signature style with the Vintage Vibes Ring. You’ll be the envy of all your friends!\n\n * Made of premium Stainless Steel, so won't discolor! \n * This ring comes in different sizes ",
  tags: [],
  msrpDollars: 28,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:02.316Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
